var _g, _path, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCardimage4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 283,
    viewBox: "0 0 282 283",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_438_855)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 0.875,
    width: 274,
    height: 274,
    rx: 30,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190.384 139.05C190.158 166.152 168.102 188.208 141 188.434C113.893 188.661 91.8397 165.812 91.6162 139.05C91.5212 127.695 73.9054 127.687 74.0004 139.05C74.1453 156.405 80.7911 172.799 92.6586 185.437C104.432 197.976 121.012 204.979 138.036 205.975C155.372 206.991 172.278 200.406 185.343 189.251C198.431 178.076 205.865 161.829 207.705 144.939C207.919 142.984 207.983 141.015 208 139.05C208.095 127.687 190.479 127.695 190.384 139.05Z",
    fill: "#4A5699"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6162 135.876C91.8426 108.773 113.897 86.7175 141 86.4911C152.354 86.3961 152.363 68.7806 141 68.8754C123.356 69.0226 106.618 75.8999 93.9512 88.1752C81.1457 100.584 74.1483 118.153 74.0004 135.876C73.9054 147.24 91.5211 147.23 91.6162 135.876Z",
    fill: "#C45FA0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.489 151.741C118.111 141.897 119.2 130.75 128.38 122.826C136.966 115.414 149.665 118.221 156.929 127.247C159.943 130.993 166.265 130.367 169.385 127.247C173.051 123.581 172.392 118.528 169.385 114.791C157.232 99.6901 134.015 96.7246 118.49 108.361C102.305 120.493 97.8936 144.109 110.278 160.632C113.152 164.465 117.829 166.428 122.329 163.791C126.116 161.573 128.376 155.592 125.489 151.741Z",
    fill: "#E5594F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M156.51 126.7C160.689 132.274 161.769 136.446 161.166 142.946C161.263 142.15 161.222 142.294 161.04 143.378C160.863 144.3 160.596 145.202 160.331 146.1C159.771 147.993 159.925 147.449 159.003 149.198C157.371 152.292 155.805 153.857 152.836 156.246C149.09 159.261 149.716 165.583 152.836 168.703C156.502 172.369 161.556 171.71 165.292 168.703C180.392 156.548 183.356 133.333 171.72 117.809C168.847 113.975 164.17 112.013 159.67 114.649C155.883 116.867 153.624 122.848 156.51 126.7Z",
    fill: "#F39A2B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_438_855",
    x: -19,
    y: -18.125,
    width: 318,
    height: 318,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_438_855"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_438_855",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -23,
    dy: -19
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_438_855"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 21,
    dy: 25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.443137 0 0 0 0 0.443137 0 0 0 0 0.443137 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_438_855",
    result: "effect3_innerShadow_438_855"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardimage4);
export default __webpack_public_path__ + "static/media/cardimage4.5dcefb36d42c2579fe1dc2418417e14c.svg";
export { ForwardRef as ReactComponent };